/**
 * @generated SignedSource<<325dc6ade8c0ed881c785fd827ebf819>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Device = "MOBILE" | "TABLET" | "PC" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type PageKind = "LANDING" | "FORM" | "CONFIRM" | "THANKS" | "%future added value";
export type SiteReportOrderField = "UNIQUE_USER" | "CONVERSION" | "CVR" | "LP_DROP_RATE" | "LP_SCROLL_RATE" | "LP_AVERAGE_STAY_TIME" | "FORM_DROP_RATE" | "MOBILE_RATE" | "TABLET_RATE" | "PC_RATE" | "DEVICE" | "PAGE_VIEW_USER" | "USE_CHATBOT_USER" | "USE_CHATBOT_USER_RATE" | "CHATBOT_CVR" | "POPUP_READY_USER" | "CLOSE_POPUP" | "CLICK_POPUP" | "POPUP_CLICK_CONVERSION" | "POPUP_IMPRESSION_CONVERSION" | "POPUP_READY_CONVERSION" | "POPUP_DROP" | "POPUP_DROP_CONVERSION" | "POPUP_CONVERSION" | "POPUP_CTR" | "POPUP_CVR" | "POPUP_CLICK_CVR" | "POPUP_IMPRESSION_CVR" | "POPUP_DROP_CVR" | "%future added value";
export type ReportInput = {
  startDate?: string | null;
  endDate?: string | null;
  orderBy?: SiteReportOrder | null;
  device?: Device | null;
  sourceId?: string | null;
  funnelIds?: ReadonlyArray<string> | null;
  pageKind?: PageKind | null;
};
export type SiteReportOrder = {
  field: SiteReportOrderField;
  direction: OrderDirection;
};
export type MonthlyReportContainer_Query$variables = {
  input: ReportInput;
  slug: string;
};
export type MonthlyReportContainer_QueryVariables = MonthlyReportContainer_Query$variables;
export type MonthlyReportContainer_Query$data = {
  readonly site: {
    readonly " $fragmentSpreads": FragmentRefs<"MonthlyReportTable_site" | "MonthlyReportGraph_site">;
  };
};
export type MonthlyReportContainer_QueryResponse = MonthlyReportContainer_Query$data;
export type MonthlyReportContainer_Query = {
  variables: MonthlyReportContainer_QueryVariables;
  response: MonthlyReportContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MonthlyReportContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MonthlyReportTable_site"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MonthlyReportGraph_site"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MonthlyReportContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "kind": "ScalarField",
            "name": "reportMonthly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "358d5b4a6e23256cbffa98463f9436d3",
    "id": null,
    "metadata": {},
    "name": "MonthlyReportContainer_Query",
    "operationKind": "query",
    "text": "query MonthlyReportContainer_Query(\n  $input: ReportInput!\n  $slug: String!\n) {\n  site(slug: $slug) {\n    ...MonthlyReportTable_site\n    ...MonthlyReportGraph_site\n    id\n  }\n}\n\nfragment MonthlyReportGraph_site on Site {\n  reportMonthly(input: $input)\n}\n\nfragment MonthlyReportTable_site on Site {\n  reportMonthly(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "bfc0d6c7a84f6a7c7db674e4fe4f0774";

export default node;
